import { useState, useEffect, useRef, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";

// Embla slider with autoplay that resets on user interaction.
export function useAutoCarousel(delay = 4500, opts = {}) {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, ...opts });
  const [selected, setSelected] = useState(0);
  const timer = useRef(null);

  const stop = useCallback(() => {
    if (timer.current) clearInterval(timer.current);
  }, []);

  const start = useCallback(() => {
    stop();
    if (embla) timer.current = setInterval(() => embla.scrollNext(), delay);
  }, [embla, delay, stop]);

  useEffect(() => {
    if (!embla) return;
    const onSelect = () => setSelected(embla.selectedScrollSnap());
    embla.on("select", onSelect);
    onSelect();
    start();
    return () => {
      stop();
      embla.off("select", onSelect);
    };
  }, [embla, start, stop]);

  const scrollTo = useCallback((i) => { embla && embla.scrollTo(i); start(); }, [embla, start]);
  const scrollNext = useCallback(() => { embla && embla.scrollNext(); start(); }, [embla, start]);
  const scrollPrev = useCallback(() => { embla && embla.scrollPrev(); start(); }, [embla, start]);

  return { emblaRef, selected, scrollTo, scrollNext, scrollPrev };
}
